import { Box, BoxProps, useTheme } from '@material-ui/core';

interface DividerProps extends BoxProps {
  orientation?: 'horizontal' | 'vertical';
  strong?: boolean;
  dashed?: boolean;
}

const Divider = ({
  orientation = 'horizontal',
  margin = 1,
  strong = false,
  dashed = false,
  ...boxProps
}: DividerProps) => {
  const { palette } = useTheme();

  const borderStyle = dashed ? `dashed 1px ${palette.grey[200]}` : `1px ${palette.grey[strong ? 300 : 200]} solid`;

  const styleByOrientation = {
    vertical: {
      height: '100%',
      borderLeft: borderStyle,
    },
    horizontal: {
      width: '100%',
      borderBottom: borderStyle,
    },
  };

  const marginY = orientation === 'horizontal' && margin;
  const marginX = orientation === 'vertical' && margin;

  return (
    <Box
      {...(marginY && { my: marginY })}
      {...(marginX && { mx: marginX })}
      {...boxProps}
      style={{ ...styleByOrientation[orientation], ...boxProps.style }}
    />
  );
};

export { Divider as CustomDivider };
